



import ShowEditComponent from "@/components/admin/show/showEditComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "ShowEditPage",
  components: {
    ShowEditComponent,
  },
})
export default class ShowEditPage extends Vue {}
